import type { ReactNode } from 'react';

/** TagFilters 下拉选项：label 可展示 ReactNode，text 用于搜索与标签回填 */
export interface FilterOption {
  label: ReactNode;
  value: string;
  /** 纯文本；未传时若 label 为 string 则用 label，否则回退 value */
  text?: string;
}

/** 取选项可用于搜索 / 标签回填的纯文本 */
export function getOptionText(option: Pick<FilterOption, 'label' | 'value' | 'text'>): string {
  if (typeof option.text === 'string' && option.text) return option.text;
  if (typeof option.label === 'string') return option.label;
  return String(option.value ?? '');
}
